/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * metapic-api
 * Metapic API
 * OpenAPI spec version: 0.0.1
 */
import * as axios from 'axios'
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'

import type {
  ClientListClientsByCountry200,
  ClientListClientsByCountryParams,
  ClientsIndex200,
  ClientsIndexParams,
} from '../metapicApi.schemas'

export const getClient = (axiosInstance: AxiosInstance = axios.default) => {
  /**
   * Endpoint for querying & sorting all clients.
   * @summary List clients
   */
  const clientsIndex = (
    params?: ClientsIndexParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<ClientsIndex200>> => {
    return axiosInstance.get(`/v2/clients`, {
      ...options,
      params: { ...params, ...options?.params },
    })
  }
  /**
   * Looks up available clients by country for a given site.
   * @summary List clients by country
   */
  const clientListClientsByCountry = (
    params?: ClientListClientsByCountryParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<ClientListClientsByCountry200>> => {
    return axiosInstance.get(`/v2/clients-by-country`, {
      ...options,
      params: { ...params, ...options?.params },
    })
  }
  return { clientsIndex, clientListClientsByCountry }
}
export type ClientsIndexResult = AxiosResponse<ClientsIndex200>
export type ClientListClientsByCountryResult = AxiosResponse<ClientListClientsByCountry200>
